exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropdown-toggle-btn[data-v-63769cf0] {\n  background-color: rgba(255, 255, 255, 0.9);\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  height: 20px !important;\n  width: 20px !important;\n}\n.dropdown-toggle-btn[data-v-63769cf0]:hover {\n  background-color: rgba(245, 245, 245, 0.9);\n  border-color: #bdbdbd;\n}\n", ""]);

// exports
